import {
  UPDATE_ORDER_TYPE,
} from './'
import { TranslationUtility } from '../../util/translationUtility';

export function PhoneNumber(state = 'tel:+14144254069', action) {
  return state;
}

export function PhoneText(state = '(414) 425-4069', action) {
  return state;
}

export function completeCheckoutButtonText(state = '', action) {
  switch(action.type) {
    case UPDATE_ORDER_TYPE:
      const translationUtility = new TranslationUtility(action.localizationItems);
      switch(action.orderType) {
        case action.onlineOrderOrderType:
          return translationUtility.translateResourceString('/Checkout/Index/Order/CheckoutButtonText');
        case action.onlineQuoteOrderType:
          return translationUtility.translateResourceString('/Checkout/Index/Quote/CheckoutButtonText');
      }
    default: 
      return state;
  }
}

export function checkoutEnvironmentMessage(state = '', action) {
  return state;
}



// WEBPACK FOOTER //
// ./src/Components/checkout/GlobalStateContainer/uiReducers.js